export const googleSignInFailure = 'googleSignInFailure'

export const googleSignInSuccess = 'googleSignInSuccess'